import { render, staticRenderFns } from "./statusBtn.vue?vue&type=template&id=2e6fd85e"
import script from "./statusBtn.vue?vue&type=script&lang=js"
export * from "./statusBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports